import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { IndividualCivilStatusTypeReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class IndividualCivilStatusTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/individualCivilStatusTypeReferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getIndividualCivilStatusTypeReferences(): Observable<IndividualCivilStatusTypeReferenceModel[]> {
        return this.httpGet<IndividualCivilStatusTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}